// Mirrors the inline script in components/bff/app/views/layouts/application_react.html.erb: keep the two in sync.
export type ColorModePreference = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'bitkitColorMode';

export const getColorModePreference = (): ColorModePreference => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'system') return stored;
  } catch {
    // Storage blocked: fall back to light.
  }
  return 'light';
};

export const applyColorMode = () => {
  const preference = getColorModePreference();
  const isOsDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const mode = preference === 'system' ? (isOsDark ? 'dark' : 'light') : preference;
  document.documentElement.classList.remove('dark', 'light');
  document.documentElement.classList.add(mode);
  document.documentElement.style.colorScheme = mode;
};

export const setColorModePreference = (preference: ColorModePreference) => {
  try {
    if (preference === 'light') localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, preference);
  } catch {
    // Storage blocked: the choice applies to this page only.
  }
  applyColorMode();
};
